"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLegacyLinkBehaviour = exports.useLinkComponents = exports.LinkComponentContextProvider = void 0;
const react_1 = __importStar(require("react"));
const LinkComponentContext = (0, react_1.createContext)({});
const LinkComponentContextProvider = ({ LinkComponent, children }) => {
    return (react_1.default.createElement(LinkComponentContext.Provider, { value: {
            LinkComponent,
        } }, children));
};
exports.LinkComponentContextProvider = LinkComponentContextProvider;
const useLinkComponents = () => {
    const context = (0, react_1.useContext)(LinkComponentContext);
    if (!context) {
        throw new Error("useLinkComponents should be used within a LinkComponentContextProvider");
    }
    const { LinkComponent } = context;
    if (!LinkComponent) {
        throw new Error("LinkComponent has not been provided to LinkComponentContextProvider. You can check if it's safe to use useLinkComponents by making sure useLegacyLinkBehaviour returns false");
    }
    return { LinkComponent };
};
exports.useLinkComponents = useLinkComponents;
/**
 * useLegacyLinkBehaviour returns a boolean indicating whether legacy
 * link behaviour should be used (true) or the revised link behaviour (false)
 * @returns
 */
const useLegacyLinkBehaviour = () => {
    const { LinkComponent } = (0, react_1.useContext)(LinkComponentContext);
    return !LinkComponent;
};
exports.useLegacyLinkBehaviour = useLegacyLinkBehaviour;
//# sourceMappingURL=linkComponentContext.js.map